export default {
  FLAG_DUMMY_FLAG: 0x00,
  FLAG_NO_RESIZE: 0x00000001,
  FLAG_BIT_02: 0x00000002,
  FLAG_BIT_03: 0x00000004,
  FLAG_BIT_04: 0x00000008,
  FLAG_BIT_05: 0x00000010,
  FLAG_BIT_06: 0x00000020,
  FLAG_BIT_07: 0x00000040,
  FLAG_BIT_08: 0x00000080,
  FLAG_BIT_09: 0x00000100,
  FLAG_BIT_10: 0x00000200,
  FLAG_BIT_11: 0x00000400,
  FLAG_BIT_12: 0x00000800,
  FLAG_BIT_13: 0x00001000,
  FLAG_BIT_14: 0x00002000,
  FLAG_BIT_15: 0x00004000,
  FLAG_BIT_16: 0x00008000,
  FLAG_BIT_17: 0x00010000,
  FLAG_BIT_18: 0x00020000,
  FLAG_BIT_19: 0x00040000,
  FLAG_BIT_20: 0x00080000,
  FLAG_BIT_21: 0x00100000,
  FLAG_BIT_22: 0x00200000,
  FLAG_BIT_23: 0x00400000,
  FLAG_BIT_24: 0x00800000,
  FLAG_BIT_25: 0x01000000,
  FLAG_BIT_26: 0x02000000,
  FLAG_BIT_27: 0x04000000,
  FLAG_BIT_28: 0x08000000,
  FLAG_BIT_29: 0x10000000,
  FLAG_BIT_30: 0x20000000,
  FLAG_BIT_31: 0x40000000,
  FLAG_BIT_32: 0x80000000,
}
